export interface Privileges {
  [key: string]: string | string[] | Privileges;
}

export abstract class BasicConfig {
  privileges?: Privileges;
}
